import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'water-action',
    templateUrl:'waterAction.html'
})
export class WaterActionComponent extends BaseActionComponent{

  public dataList;
  public media
  public level=1;
  public kind='water';
  public waterColor='#0d5c8c';
  public distortionScale=20;
  public waterNormals='';
  public customNormals=false;
  public linkForm: FormGroup;
  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }
  public processData(action){
    if (!action){
      action={kind:'water',param:{}}
    }
    let dx=action.param.dx ? action.param.dx : 10;
    let dy=action.param.dy ? action.param.dy : 10
    let thumbnail=null;
    if (this.media){
      thumbnail=this.media.url
    }
    let linkParam = this.linkForm['_value'];
    action.param=linkParam
    action.param.dx=dx
    action.param.dy=dy

    if (thumbnail){
      action.param.url=thumbnail
    }
    action.param.kind=this.kind
    action.param.waterNormals=this.waterNormals ? this.waterNormals : ''
    action.param.distortionScale=Number(action.param.distortionScale)
  }
  public waterSelect(j){
    if (this.waterNormalsList[j]){
      this.waterNormalsList[j].selected=true;
      this.waterNormals=this.waterNormalsList[j].url;
      this.customNormals=this.waterNormalsList[j].custom ? true : false;
      this.linkForm.patchValue({distortionScale:this.distortionScale});
      this.updatePreview();
    }
  }
  public selectItem(item) {
    this.media=null
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id == item.id) {
          this.dataList[i].selected = true;
          this.media=item
      }
      else {
          this.dataList[i].selected = false;
      }
    }
  }
  public gotoLink(item){
    if (item && item.url){
      window.open(item.url, '_blank');
    }
  }
  public updatePreview(){
    this.waterColor=this.linkForm.controls['waterColor'].value;
    this.distortionScale=this.linkForm.controls['distortionScale'].value;
    let color=this.waterColor ? this.waterColor : '#0d5c8c';
    setTimeout(()=>{
      let el=document.getElementById('waterPreview')
      if (el){
        el.style.background='linear-gradient(180deg,'+color+' 0%, '+color+' 55%, #ffffff 100%)'
      }
    },0)
  }
  public clearSelection(){
    this.media=null;
    this.waterNormals='';
    this.customNormals=false;
    if (this.dataList){
      for (let i = 0; i < this.dataList.length; i++) {
          this.dataList[i].selected = false;
      }
    }
    if (this.waterNormalsList){
      for (let i = 0; i < this.waterNormalsList.length; i++) {
          this.waterNormalsList[i].selected = false;
      }
    }
  }
  public waterNormalsList=[
    {name:'Nenhum',url:'',custom:false,selected:false},
    {name:'Water normals (padrão three.js)',url:'https://threejs.org/examples/textures/waternormals.jpg',custom:false,selected:false},
    {name:'Personalizada...',url:'custom',custom:true,selected:false}
  ];
  public reloadLocalPacks(){
    let list=[]
    if (this.selectedPack){
      list=this.selectedPack.images
    }
    else{
      if (this._appData.room.textures.images) {
        list=this._appData.room.textures.images
      }
    }
    this.dataList = []
    if (this.action.param && this.action.param.url && this.action.param.url.indexOf('http')>=0){
      list.forEach(ic => {
        ic.url = ic.url
        ic.selected = false
        if (this.action.param) {
          if ((this.action.param.url) == ic.url) {
            ic.selected = true;
            this.media=ic
          }
        }
        this.dataList.push(ic);
      })
    }
    else{
      if (this.selectedPack){
        list.forEach(ic => {
          ic.selected = false
          if ((this.action.param && this.action.param.url) == 'pack-'+this.selectedPack.id+'-id-'+ic.id) {
              ic.selected = true;
              this.media=ic
          }
          this.dataList.push(ic);
        })
      }
      else{
        //nao é um pack veio das texturas.
        list.forEach(ic => {
          ic.selected = false
          if (!ic.id){ic.id=ic.transaction;}
          if (this.action.param.url){
            if ((this.action.param.url) == 'texture-'+ic.id) {
              ic.selected = true;
              this.media=ic
            }
          }
          this.dataList.push(ic);
        })
      }
    }
  }

  public childrenReloadData(){
    let list=[]
    let split=null
    if (this.action.param && this.action.param.url){
      split=this.action.param.url.split('-')
      if (split.length>0 && split[0]=='pack'){
        this.selectedPack=this._appData.room.packs[split[1]]
      }
    }
    if (this.action.param.kind){
      this.kind=this.action.param.kind
    }
    if (this.action.param){
      this.waterColor=this.action.param.waterColor ? this.action.param.waterColor : '#0d5c8c';
      this.distortionScale=this.action.param.distortionScale ? Number(this.action.param.distortionScale) : 20;
      this.waterNormals=this.action.param.waterNormals ? this.action.param.waterNormals : '';
      this.customNormals=false;
      for (let i = 0; i < this.waterNormalsList.length; i++) {
        this.waterNormalsList[i].selected=false;
        if (this.waterNormalsList[i].custom){
          if (this.waterNormals && this.waterNormals==this.waterNormalsList[i].url){
            this.waterNormalsList[i].selected=true;
            this.customNormals=true;
          }
        }
        else if (this.waterNormalsList[i].url==this.waterNormals){
          this.waterNormalsList[i].selected=true;
        }
      }
    }
    else{
      this.waterColor='#0d5c8c';
      this.distortionScale=20;
      this.waterNormals='';
      this.customNormals=false;
    }
    this.linkForm = this.fb.group({
      waterColor: this.waterColor,
      distortionScale: this.distortionScale
    });
    this.reloadLocalPacks();
    this.updatePreview();
  }

    public ngOnInit(): any {
      this.linkForm = this.fb.group({
        waterColor: this.waterColor,
        distortionScale: this.distortionScale
      });
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/waterAction.ts